export function isOtaEventForDevice(event, deviceId) {
  return Number(event?.deviceId) === Number(deviceId);
}

export function shouldHandleOtaEvent(event, deviceId, activeSessionId) {
  if (!isOtaEventForDevice(event, deviceId)) return false;
  if (activeSessionId && event.sessionId !== activeSessionId) return false;
  return true;
}

export const INITIAL_OTA_STATE = {
  status: 'idle',
  progress: 0,
  sessionId: null,
  error: '',
};

export function reduceOtaState(prev, event) {
  if (!event) return prev;
  return {
    ...prev,
    status: event.status,
    progress: event.progress ?? prev.progress,
    sessionId: event.sessionId ?? prev.sessionId,
    error: event.error || event.message || prev.error || '',
  };
}

export function getOtaProgressMessage(event) {
  switch (event?.status) {
    case 'complete':
      return '✅ OTA complete. Device is restarting with new firmware.';
    case 'error':
      return `Failed: ${event.error || event.message || 'OTA failed'}`;
    case 'transferring':
      return `Sending firmware chunk ${event.chunk || 0} of ${event.totalChunks || '?'}`;
    case 'finalizing':
      return 'Finalizing update on device...';
    default:
      return null;
  }
}